module.exports = __webpack_public_path__ + "static/media/Polygon-grey.1562f289.svg";